import styled from 'styled-components'

const Box = styled.div`
  background: transparent;
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};
  position: relative;
  min-height: 32px;
  border-radius: 24px;
  font-weight: bold;
  font-size: 14px;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.1);
  transition: border-color 200ms ease;

  &:focus-within {
    border-color: rgba(139, 92, 246, 0.5);
  }
`
const ActiveBoxContainer = styled(Box)`
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};
  border-radius: 24px;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.1);
`

const EBoxSmInput = ({ children, isActive = false, ...rest }) => {
  if (isActive) {
    return <ActiveBoxContainer {...rest}>{children}</ActiveBoxContainer>
  }

  return <Box {...rest}>{children}</Box>
}

export default EBoxSmInput
